// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldExtraProps,
    CustomFieldExtraPropsFromJSON,
    CustomFieldExtraPropsToJSON,
    CustomFieldType,
    CustomFieldTypeFromJSON,
    CustomFieldTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomField
 */
export interface CustomField {
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    entity?: string;
    /**
     * 
     * @type {CustomFieldType}
     * @memberof CustomField
     */
    type: CustomFieldType;
    /**
     * NULL if default value not specified, Number type for dropdown field and date, string types for other
     * @type {string}
     * @memberof CustomField
     */
    defaultValue: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    isRequired: boolean;
    /**
     * Should link with all projects?
     * @type {boolean}
     * @memberof CustomField
     */
    addToAllProjects?: boolean;
    /**
     * Project IDs in array. Can only be specified if `add_to_all_projects` is false
     * @type {Array<number>}
     * @memberof CustomField
     */
    projects?: Array<number>;
    /**
     * Weather to make this field searchable or not
     * @type {boolean}
     * @memberof CustomField
     */
    search?: boolean;
    /**
     * 
     * @type {CustomFieldExtraProps}
     * @memberof CustomField
     */
    extra?: CustomFieldExtraProps;
    /**
     * Company ID
     * @type {number}
     * @memberof CustomField
     */
    company: number;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    isSortable?: boolean;
}

export function CustomFieldFromJSON(json: any): CustomField {
    return {
        'id': json['id'],
        'sortOrder': !exists(json, 'sort_order') ? undefined : json['sort_order'],
        'name': json['name'],
        'label': json['label'],
        'entity': !exists(json, 'entity') ? undefined : json['entity'],
        'type': CustomFieldTypeFromJSON(json['type']),
        'defaultValue': json['default_value'],
        'isRequired': json['is_required'],
        'addToAllProjects': !exists(json, 'add_to_all_projects') ? undefined : json['add_to_all_projects'],
        'projects': !exists(json, 'projects') ? undefined : json['projects'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'extra': !exists(json, 'extra') ? undefined : CustomFieldExtraPropsFromJSON(json['extra']),
        'company': json['company'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isSortable': !exists(json, 'is_sortable') ? undefined : json['is_sortable'],
    };
}

export function CustomFieldToJSON(value?: CustomField): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'sort_order': value.sortOrder,
        'name': value.name,
        'label': value.label,
        'entity': value.entity,
        'type': CustomFieldTypeToJSON(value.type),
        'default_value': value.defaultValue,
        'is_required': value.isRequired,
        'add_to_all_projects': value.addToAllProjects,
        'projects': value.projects,
        'search': value.search,
        'extra': CustomFieldExtraPropsToJSON(value.extra),
        'company': value.company,
        'description': value.description,
        'is_sortable': value.isSortable,
    };
}


